import { createRoute } from "@tanstack/react-router";
import { requirePermissions } from "@/app/guards";
import { SIGNATURES_PERMISSIONS } from "@/app/nav";
import { SignatureDetailPage } from "@/features/signatures/SignatureDetailPage";
import { SignatureList } from "@/features/signatures/SignatureList";
import { staffRoute } from "@/routes/staff";

export const signaturesRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "signatures",
  beforeLoad: ({ context }) => requirePermissions(context.session, SIGNATURES_PERMISSIONS),
  component: SignatureList,
});

export const signatureDetailRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "signatures/$signatureId",
  beforeLoad: ({ context }) => requirePermissions(context.session, SIGNATURES_PERMISSIONS),
  component: SignatureDetailPage,
});
